import { render, staticRenderFns } from "./general-vocations.vue?vue&type=template&id=71789caa"
import script from "./general-vocations.vue?vue&type=script&lang=js"
export * from "./general-vocations.vue?vue&type=script&lang=js"
import style0 from "./general-vocations.vue?vue&type=style&index=0&id=71789caa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports